<template>
    <div class="container single_page">
        <div class="row justify-content-md-center">
            <div v-if="data.image" class="col col-lg-10">
                <img v-if="data.image.path" v-bind:src="'http://www.clun-forest.sk/'+data.image.path"/>
            </div>
        </div>
        <div class="row justify-content-md-center">            
            <div class="col col-lg-10">
                <h1>{{data.title}}</h1>
            </div>
        </div>
        <div class="row justify-content-md-center">            
            <div v-if="data.date" class="col col-lg-10">
                <span>{{ data.date | formatDate }}</span>
            </div>
        </div>
        <div class="row justify-content-md-center">            
            <div class="col col-lg-10">
                <p v-html="data.text">{{ data.text }}</p>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';

export default {
    data() {
        return {
            data: [],
            errors: []
        }
    },

    // Fetches posts when the component is created.
    created() {
        var authOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
            url: 'http://www.clun-forest.sk/cockpit/api/collections/get/news?token=715b9f9a9f192319672a7a842fc494',
            json: true
        };
        axios(authOptions)
        .then(response => {
            response.data.entries.forEach(element => {
                if (element._id == this.$route.params.id) {
                    this.data = element;
                }
            });  
            console.log(this.data);          
        })
        .catch(e => {
            this.errors.push(e)
        })
    }
}
</script>
<style>
    .single_page .col img {
          max-width:100%
    }
</style>



// WEBPACK FOOTER //
// src/components/BlogDetail.vue